export function _getUrlParams(url) {
    var i
    url = url || window.location
    url = url.indexOf ? url : url.toString()
    url = decodeURIComponent(url)

    var paramStringStart = url.indexOf('?') + 1,
        paramStringEnd = (url.indexOf('#') === -1) ? url.length : url.indexOf('#'),
        paramString = url.slice(paramStringStart, paramStringEnd),
        keysAndValues = paramString.split('&'),
        paramsObject = {}

    for (i = 0; i < keysAndValues.length; i++) {
        var keyValue = keysAndValues[i].split('=')

        if (keyValue[0].slice(-2) === '[]') {
            var key = keyValue[0].slice(0, -2)
            paramsObject[key] = paramsObject[key] || []
            paramsObject[key].push(keyValue[1])
        } else {
            paramsObject[keyValue[0]] = keyValue[1]
        }
    }

    return paramsObject
}

export function _parseUrl(url = location.href) {
    let a = document.createElement('a')
    a.href = url
    return {
        source: url,
        protocol: a.protocol.replace(':', ''),
        host: a.hostname,
        port: a.port,
        query: a.search,
        params: (function () {
            let ret = {}
            let seg = a.search.replace(/^\?/, '').split('&')
            let len = seg.length
            let i = 0
            let s
            for (; i < len; i++) {
                if (!seg[i]) {
                    continue
                }
                s = seg[i].split('=')
                ret[s[0]] = s[1]
            }
            return ret
        })(),
        file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
        hash: a.hash.replace('#', ''),
        path: a.pathname.replace(/^([^\/])/, '/$1'),
        relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
        segments: a.pathname.replace(/^\//, '').split('/')
    }
}

export function _appendUrlParam(url, key, value) {
    let separator = url.indexOf('?') > -1 ? '&' : '?'
    let extraParam = `${separator}${key}=${value}`
    url += extraParam
    return url;
}

export function _http2https(adUnits) {
    var httpsMap = {
        'http://cdn-adn.rayjump.com': 'https://cdn-adn-https.rayjump.com',
        'http://res.rayjump.com': 'https://res-https.rayjump.com',
        'http://d11kdtiohse1a9.cloudfront.net': 'https://res-https.rayjump.com'
    }
    for (var i = 0; i < adUnits.length; i++) {
        for (var k in adUnits[i]) {
            for (var key in httpsMap) {
                var reg = new RegExp('' + key + '')
                if (reg.test(adUnits[i][k])) {
                    adUnits[i][k] = adUnits[i][k].replace(reg, httpsMap[key])
                }
            }
        }
    }
}

/* 使用JS原生方法获取id元素或者class元素 */
export function _getEl(el, tagName) {
    el = el.replace(/^\s|\s$/g, '')
    // # id . class tag
    var first = el.substr(0, 1)
    // console.log(first);

    if (first === '#') {
        return document.getElementById(el.substr(1, el.length))
    }

    if (first === '.') {
        return document.getElementsByClassName(el.substr(1, el.length))
    }
}

/* 使用JS原生方法删除元素节点，如果这个节点有父节点的话 */
export function _rmEl(el) {
    var oParent = el.parentNode
    if (oParent) {
        oParent.removeChild(el)
    }
}

export function _addClass(el, className) {
    var reg = new RegExp('' + className + '')
    if (!reg.test(el.className)) {
        // if dosent exsist
        el.className += (' ' + className)
    }
}

export function _rmClass(el, className) {
    var reg = new RegExp('' + className + '')
    if (reg.test(el.className)) {
        el.className = el.className.replace(reg, '')
    }
}

export function _language() {
    var type = navigator.appName
    var lang = ''
    if (type == 'Netscape') {
        lang = navigator.language
    } else {
        lang = navigator.userLanguage
    }
    lang = lang.substr(0, 2)
    switch (lang) {
        case 'en':
            break
        case 'zh':
            break
        default:
            lang = 'other'
    }
    return lang
}

export function _ajax(type, url, data, success, failed) {
    // 创建ajax对象
    if (typeof data == 'object') {
        var str = '';
        for (var key in data) {
            str += key + '=' + data[key] + '&';
        }
        data = str.replace(/&$/, '');
    }
    type = type.toUpperCase();
    if (type == 'GET') {
        if (data) {
            xhr.open('GET', url + '?' + data, true);
        } else {
            xhr.open('GET', url, true);
        }
        xhr.send();

    } else if (type == 'POST') {
        xhr.open('POST', url, true);
        // 如果需要像 html 表单那样 POST 数据，请使用 setRequestHeader() 来添加 http 头。
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.send(data);
    } else if (type == 'POSTJSON') {
        xhr.open('POST', url, true);
        // 如果需要像 html 表单那样 POST 数据，请使用 setRequestHeader() 来添加 http 头。
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }

    // 处理返回数据
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status == 200) {
                success(xhr.responseText);
            } else {
                if (failed) {
                    failed(xhr.responseText);
                }
            }
        }
    }
}

export function _statistics(url, silentTag) {
    var reg = /(http\:|https\:)/
    silentTag = silentTag || 'script'
    url = url.replace(reg, '')
    var silentDataUrlString = url
    var oTag = document.createElement(silentTag)
    oTag.setAttribute('src', silentDataUrlString)
    document.body.appendChild(oTag)
}

// 判断页面滚动方向
export function _scrollFunc() {
    var scrollAction = {
            x: 0,
            y: 0
        },
        scrollDirection
    var diffX = scrollAction.x - window.pageXOffset
    var diffY = scrollAction.y - window.pageYOffset
    // console.log(diffX, diffY)
    if (diffX < 0) {
        // Scroll right
        scrollDirection = 'right'
    } else if (diffX > 0) {
        // Scroll left
        scrollDirection = 'left'
    } else if (diffY < 0) {
        // Scroll down
        scrollDirection = 'down'
    } else if (diffY > 0) {
        // Scroll up
        scrollDirection = 'up'
    } else {
        // First scroll event
        // console.log(11111)
        scrollDirection = ''
    }
    scrollAction.x = window.pageXOffset
    scrollAction.y = window.pageYOffset
    // console.log(scrollAction, scrollDirection)
    return scrollDirection
}

// 文档高度
export function _getDocumentTop() {
    var scrollTop = 0,
        bodyScrollTop = 0,
        documentScrollTop = 0
    if (document.body) {
        bodyScrollTop = document.body.scrollTop
    }
    if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop
    }
    scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop
    return scrollTop
}

// 可视窗口高度
export function _getWindowHeight() {
    var windowHeight = 0
    if (document.compatMode === 'CSS1Compat') {
        windowHeight = document.documentElement.clientHeight
    } else {
        windowHeight = document.body.clientHeight
    }
    return windowHeight
}

// 可视窗口宽度
export function _getWindowWidth() {
    var windowWidth = 0
    if (document.compatMode === 'CSS1Compat') {
        windowWidth = document.documentElement.clientWidth
    } else {
        windowWidth = document.body.clientWidth
    }
    return windowWidth
}

// 可视窗口高度 和 宽度
export function _getWinWH() {
    let ww = 0
    let wh = 0
    if (document.compatMode === "CSS1Compat") {
        ww = document.documentElement.clientWidth;
        wh = document.documentElement.clientHeight;
    } else {
        ww = document.body.clientWidth;
        wh = document.body.clientHeight;
    }
    return {
        ww,
        wh
    }
}

export function _isPad() {
    let {ww, wh} = _getWinWH()
    console.warn('isPad: ', {ww, wh})
    // return wh >= 1380 && ww >= 1900 || wh >= 1900 && ww >= 1380;
    return wh >= 768 && ww >= 1024 || wh >= 1024 && ww >= 768;
}

// 滚动条滚动高度
export function _getScrollHeight() {
    var scrollHeight = 0,
        bodyScrollHeight = 0,
        documentScrollHeight = 0
    if (document.body) {
        bodyScrollHeight = document.body.scrollHeight
    }
    if (document.documentElement) {
        documentScrollHeight = document.documentElement.scrollHeight
    }
    scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight
    return scrollHeight
}

export function _device() {
    var u = navigator.userAgent
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    return {
        isAndroid: isAndroid,
        isiOS: isiOS
    }
}

export function _toggleLogo() {
    var i
    var parm = _getUrlParams()
    var rVersion = /(mal|mi)/ig
    if (parm && parm.sdk_version) {
        if (rVersion.test(parm.sdk_version)) {
            for (i = 0; i < _getEl('.logo').length; i++) {
                _rmClass(_getEl('.logo')[i], 'none')
            }
        }
    }
}

/*
 * Interfaces:
 * utf8 = utf16to8(utf16);
 * utf16 = utf8to16(utf8);
 */
export function _utf16to8(str) {
    var out, i, len, c
    out = ''
    len = str.length
    for (i = 0; i < len; i++) {
        c = str.charCodeAt(i)
        if ((c >= 0x0001) && (c <= 0x007F)) {
            out += str.charAt(i)
        } else if (c > 0x07FF) {
            out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F))
            out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F))
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F))
        } else {
            out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F))
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F))
        }
    }
    return out
}

export function _utf8to16(str) {
    var out, i, len, c
    var char2, char3
    out = ''
    len = str.length
    i = 0
    while (i < len) {
        c = str.charCodeAt(i++)
        switch (c >> 4) {
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                // 0xxxxxxx
                out += str.charAt(i - 1)
                break
            case 12:
            case 13:
                // 110x xxxx 10xx xxxx
                char2 = str.charCodeAt(i++)
                out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F))
                break
            case 14:
                // 1110 xxxx 10xx xxxx 10xx xxxx
                char2 = str.charCodeAt(i++)
                char3 = str.charCodeAt(i++)
                out += String.fromCharCode(((c & 0x0F) << 12) |
                    ((char2 & 0x3F) << 6) |
                    ((char3 & 0x3F) << 0))
                break
        }
    }
    return out
}

export function _fnIsPortrait() {
    var isOrientation = ('orientation' in window && 'onorientationchange' in window),
        meta = ''
    // iframe中orientation并不准确
    if (isOrientation && window.self === window.top) {
        // eslint-disable-next-line no-undef
        if (orientation === 180 || orientation === 0) {
            meta = 'portrait'
        }
        // eslint-disable-next-line no-undef
        if (orientation === 90 || orientation === -90) {
            meta = 'landscape'
        }
    } else {
        if (window.innerWidth > window.innerHeight) { // 初始化判断
            meta = 'landscape'
        } else {
            meta = 'portrait'
        }
    }
    return meta === 'portrait'
}

export function _getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return decodeURIComponent(r[2])
    return null
}

export function _tips(msg) {
    let tips_center = document.createElement('div')
    tips_center.textContent = msg
    tips_center.style.cssText = "font-size:100%; padding: .6em; background-color: rgba(0,0,0,.8); border-radius: 1em; position: absolute; left: 50%; top: 50%; -webkit-transform: translate3d(-50%,-50%,0); -moz-transform: translate3d(-50%,-50%,0); -ms-transform: translate3d(-50%,-50%,0); -o-transform: translate3d(-50%,-50%,0); transform: translate3d(-50%,-50%,0); "
    document.body.appendChild(tips_center)
    clearTimeout(this.timmer)
    this.timmer = setTimeout(function () {
        tips_center.textContent = ''
        tips_center.style.display = 'none'
    }, 3000)
}

/**
 * 一个定时监听器, 支持设置最大时限
 * @param condition 执行 callback 的条件, 必须是一个可以执行函数, 以确保每次可以拿到最新的状态
 * @param callback 符合条件时就会执行 callback
 * @param timeoutCallback 监听超时的情况下才会执行的回调函数()
 * @param maxDuration 最大监听时限, 超过时限就会自动停止监听, 默认 5 秒
 * @param maxRepeatTimes 最大重复次数, 和 maxDuration 共同控制监听器, 任何一个条件满足均会停止走超时逻辑
 * @param interval 监听频率
 */
export function _watchdog({
                              condition = () => false,
                              callback = () => {
                              },
                              timeoutCallback = () => {
                              },
                              maxDuration = 5000,
                              interval = 100
                          }) {
    if (condition && condition()) {
        callback()
    } else {
        let counter = 0
        let timerRepeat = null
        let timerOnce = null
        // 未超时的情况下循环调用 callback
        timerRepeat = setInterval(function () {
            ++counter
            if (condition && condition()) {
                console.log(`watchdog: 提前满足条件中止, 当前第${counter}次循环`, {condition: condition && condition()})
                clearTimeout(timerOnce)
                clearInterval(timerRepeat)
                callback()
            }
        }, interval)

        // 超时
        timerOnce = setTimeout(function () {
            console.log(`watchdog: 超时, 已经循环了${counter}次`, {condition: condition && condition()})
            clearInterval(timerRepeat)
            timeoutCallback()
        }, maxDuration)
    }
}

export function _logSuccess(msg, data) {
    console.log(`%c√ ${msg}: `, `color:green`, data)
}

export function _logWaring(msg, data) {
    console.log(`%c√ ${msg}: `, `color:gold`, data)
}

export function _logError(msg, data) {
    console.log(`%c√ ${msg}: `, `color:red`, data)
}